import LinkButton from "../../../global/components/LinkButton"
import { useState } from "react";


const showcaseImages = [
  {
    src: 'CutcoCar.png',
    alt: 'Cutco Car',
    desc: '(2024) Me in the Cutco Car at Olean, NY, where I worked as a sales rep.',
  },
  {
    src: 'beachWalk.jpg',
    alt: 'Beach Walk',
    desc: '(2021) Me walking on Siesta Key Beach in Sarasota Florida, where I lived for five years.',
  },
]


const ImageGallery = ({ images }) => {
  const publicURL = process.env.PUBLIC_URL;

  const [currentIndex, setCurrentIndex] = useState(0);
  const goTo = ({next}) => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? images.length - 1 :
      prevIndex === images.length - 1 ? 0 :
      next ? prevIndex + 1 : prevIndex - 1
    );
  };

  return (
    <div className="relative w-full max-w-4xl mx-auto">

      {/* Main Div */}
      <div className="flex flex-row gap-4 mt-6 justify-center">
        <div className="flex flex-col items-center gap-4">
          <img
            src={`${publicURL}${images[currentIndex].src}`}
            alt={images[currentIndex].alt}
            className="rounded-lg w-96 h-96 object-cover border-4 border-blue-950"
            loading="lazy"
          />
          <p className="text-center black-ops-font text-lg">{images[currentIndex].desc}</p>
        </div>
      </div>

      {/* Left Arrow */}
      <button
        onClick={() => goTo({next: false})}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-black bg-opacity-50 hover:bg-opacity-75 text-white p-3 rounded-full transition-all duration-200 hover:scale-110"
        aria-label="Previous image"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      {/* Right Arrow */}
      <button
        onClick={() => goTo({next: true})}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-blue-950 bg-opacity-50 hover:bg-opacity-75 text-white p-3 rounded-full transition-all duration-200 hover:scale-110"
        aria-label="Next image"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
        </svg>
      </button>

      {/* Image Counter */}
      <div className="hidden md:block absolute top-4 right-4 bg-blue-950 bg-opacity-50 text-white px-3 py-1 rounded-full text-sm">
        {currentIndex + 1} / {images.length}
      </div>
    </div>
  )
}


export default function About() {
  const currentYear = new Date().getFullYear();
  const yearsOfExperience = currentYear - 2015;

  return (
    <div className="portfolio-container about">

      {/* About Me Section */}
      <div className="bg-blue-800 rounded-lg p-6 max-w-4xl mx-auto border-4 border-blue-950">
        <h1 className="mb-10">About Me</h1>
        <p className="text-4xl black-ops-font">
            Welcome to my digital universe!
        </p>
        <p>
            I began coding in 2015, teaching myself how to build Roblox games as a hobby using Roblox's
            programming language, Lua. 
        </p>
        <p>
            Over {yearsOfExperience} years later, I still thrive in the digital experiences I build!
        </p>
        <p>
            I revel in the ever-evolving landscape of technology, finding boundless joy in the ingenuity and
            creative possibilities it unfolds, from video games to web development and beyond.
        </p>
        <p>
            I find artistic inspiration in building websites for others, bringing their ideas to life through code.
            Whether it be through no-code platforms or hand-coding from scratch, I love the process of creating something
            unique and functional.
        </p>
        <p>
            Aside from web development and technology, I'm also passionate about mathematics, video games, art, and
            self-improvement. I find joy in learning about the world God has created, whether it be through reading, exploring new
            hobbies, or engaging in meaningful conversations with others.
        </p>
        <p>
            View my blog page below to learn more about my interests!
        </p>
        <LinkButton to="/blog">
            View BlogPage
        </LinkButton>

        <ImageGallery images={showcaseImages} />
      </div>

    </div>
  )
}
